// Mobile-money payment helpers (Wave + Orange Money). No API keys — deep links only.

export function phoneDigits(phone) {
  return (phone || "").replace(/[^\d]/g, "");
}

export function hasPaymentConfig(t) {
  return !!(t && (t.wave_link || t.wave_number || t.om_number));
}

export function normalizeWaveLink(link) {
  if (!link) return "";
  const l = link.trim();
  if (/^https?:\/\//i.test(l)) return l;
  return `https://${l}`;
}

// Message the tailor shares to the client (via WhatsApp) so the client can pay.
export function buildPaymentMessage(tailleur, amount, clientName) {
  const lines = [];
  lines.push(`💳 DEMANDE DE PAIEMENT`);
  if (clientName) lines.push(`Bonjour ${clientName},`);
  const atelier = tailleur?.atelier || tailleur?.nom || "votre tailleur";
  lines.push(`Merci de régler ${atelier}${amount ? ` : ${Number(amount).toLocaleString("fr-FR")} FCFA` : ""}.`);
  lines.push("");
  if (tailleur?.wave_link) {
    lines.push(`🌊 Wave (ouvrir le lien) :`);
    lines.push(normalizeWaveLink(tailleur.wave_link));
  } else if (tailleur?.wave_number) {
    lines.push(`🌊 Wave : envoyez au ${tailleur.wave_number}`);
  }
  if (tailleur?.om_number) {
    lines.push(`🟠 Orange Money : envoyez au ${tailleur.om_number} (composez #144#)`);
  }
  lines.push("");
  lines.push("✂️ Via Tailleur Pro");
  return lines.join("\n");
}

export function whatsappTo(phone, message) {
  const d = phoneDigits(phone);
  const text = encodeURIComponent(message);
  return d ? `https://wa.me/${d}?text=${text}` : `https://wa.me/?text=${text}`;
}
